module.exports = __webpack_public_path__ + "img/France_Inter_logo_2021.2402dcae.svg";